import { memoizedGroupBySelector } from '@travelnest/entities';
import { getProperty } from '../entities/properties/selectors';
import { IState } from '../store/reducer';
import { IProperty } from './entities/property';
import { ILocalLicence } from './entities/property/local_licence';

/**
 * Retrieve a fully-hydrated property from each of the sub-entities in state
 * (Note this does not load entities)
 * @param propertyId - The property ID of the property to hydrate
 * @param state - The redux state
 */
export const getHydratedProperty = (propertyId: string | number, state: IState): IProperty | undefined  => {
	const property = getProperty(propertyId, state);

	if (property) {
		const amenitiesByProperty = memoizedGroupBySelector('property', state.data.amenities.byId);
		const restrictionsByProperty = memoizedGroupBySelector('property', state.data.restrictions.byId);
		const bathroomsByProperty = memoizedGroupBySelector('property', state.data.bathrooms.byId);
		const bedsByProperty = memoizedGroupBySelector('property', state.data.beds.byId);
		const accountsByProperty = memoizedGroupBySelector('property', state.data.accounts.byId);
		const localLicenceByProperty = memoizedGroupBySelector('property', state.data.localLicence.byId);

		property.amenities = amenitiesByProperty[property.id] || [];
		property.beds = bedsByProperty[property.id] || [];
		property.bathrooms = bathroomsByProperty[property.id] || [];
		property.restrictions = restrictionsByProperty[property.id] || [];
		property.accounts = accountsByProperty[property.id] || [];
		property.local_licence = localLicenceByProperty[property.id] ? localLicenceByProperty[property.id][0] : {} as ILocalLicence;
	}

	return property;
};
